import styled from 'styled-components'

export const Title = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.E};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`
